/** @flow */

import {
  GetSharedEmployeePositionsSuccess,
  GetSharedEmployeePositionsError,
} from "@modules/shared/constants/actions";
import * as employeePositionsReducers from "./reducers";
import initialState from "./state";
import type { EmployeePositionsState } from "./types";
import { cloneObject } from "@utils/object";

export default (state: EmployeePositionsState = initialState, action: Object): Object => {
  const act = {
    [GetSharedEmployeePositionsSuccess]:
      employeePositionsReducers.onGetSharedEmployeePositionsSuccess,
    [GetSharedEmployeePositionsError]: employeePositionsReducers.onGetSharedEmployeePositionsError,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
